/** The `/read/<slug>` URL space, in one place — the studio's ONLY path-routed
 *  surface (everything else is hash-routed; see lib/url-state.ts).
 *
 *  Path-routed on purpose: these pages are handed to people outside the app, so
 *  the URL has to be clean, crawlable, and prerenderable to a static file. The
 *  build writes `dist/read/<slug>/index.html` for every published document, so
 *  the prefix is served by plain static hosting with no server route — see
 *  `publicDocPages()` in vite.config.ts. */
export const PUBLIC_DOC_PREFIX = "/read/";

/** The published slug a pathname addresses, or null if it addresses anything
 *  else. Only lowercase hyphenated slugs resolve, and a trailing slash is
 *  optional (a directory URL served as `/read/<slug>/index.html` arrives with
 *  one; a shared link usually does not). Membership is NOT checked here —
 *  `findPublicDoc` owns "is anything published at this slug". */
export function publicDocSlug(pathname: string): string | null {
  if (!pathname.startsWith(PUBLIC_DOC_PREFIX)) return null;
  const slug = pathname.slice(PUBLIC_DOC_PREFIX.length).replace(/\/+$/, "");
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug) ? slug : null;
}

/** The public URL path for a slug. One definition, so the prerenderer, the
 *  router, and any link to a published document agree. */
export function publicDocPath(slug: string): string {
  return `${PUBLIC_DOC_PREFIX}${slug}`;
}
